import React from "react"
import { StyleSheet, Text, View } from "react-native"

import Base from "../../base"
import { CustomSwitch } from "../common"

export default function VenueEnableView(props) {
  return (
    <View style={styles.main}>
      <Text style={[Base.styles.title_md, styles.title]}>Venue</Text>
      <View key={props.index} style={styles.switchRow}>
        <Text style={styles.switchTitle}>
          {"Enable " + props.service.title}
        </Text>
        <CustomSwitch
          value={props.service.isEnabled}
          onValueChange={() => props.onPress(props.service)}
          autoWidth
        />
      </View>
    </View>
  )
}

const styles = StyleSheet.create({
  main: {
    marginVertical: 24,
  },

  title: {
    marginBottom: 24,
  },

  switchRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    height: 48,
    borderRadius: 24,
    backgroundColor: "white",
    paddingRight: 10,
    paddingLeft: 15,
    marginBottom: 15,
  },

  switchTitle: {
    marginEnd: 10,
    fontSize: 16,
    color: Base.colours.appDarkBlue,
    fontFamily: Base.fonts.appExtraBold,
  },
})
